<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome do cidadão"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal
                :texto="texto_esus_pec"
                :data="data_esus_pec"
              />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.dt_ultima_ficha="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data da última atualização do Cadastro Individual (CI) do cidadão"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.dt_ultima_ficha="{ item }">
            {{ formatDate(item.dt_ultima_ficha) }} <br />
            ({{ item.percent_fci_completa }}%)
          </template>

          <template v-slot:item.acompanhamento="{ item }">
            <div v-if="item.ultimo_acompanhamento == null">Sem atendimento</div>
            <div v-else class="ultimo-acompanhamento">
              {{
                item.ultimo_acompanhamento.dt_atendimento != undefined
                  ? formatDate(item.ultimo_acompanhamento.dt_atendimento)
                  : ''
              }}
              <span>
                {{ item.ultimo_acompanhamento.tipo }}
              </span>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>CI</th>
                    <th>CDT</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>

                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>
                      {{ formatDate(item.dt_ultima_ficha) }} <br />
                      ({{ item.percent_fci_completa }}%)
                    </td>
                    <td>
                      {{ formatDate(item.dt_ultima_fcd) }} <br />
                      ({{ item.percent_fcdt_completa }}%)
                    </td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>Vulnerabilidade</th>
                    <th>eSF ou eAP</th>
                    <th>Odonto</th>
                    <th>eMulti</th>
                    <th>Procedimento</th>
                    <th>Coletivo</th>
                    <th>Alimentar</th>
                    <th>Visita</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.vulnerabilidade.replace(/^\[|\]$/g, '') }}
                    </td>
                    <td>
                      {{
                        item.ult_fai_esf_eap !== null
                          ? formatDate(item.ult_fai_esf_eap)
                          : ''
                      }}
                      <br />
                      <div v-if="item.ult_fai_esf_eap != null">
                        ({{ item.qtd_esf_eap }} atendimentos)
                      </div>
                    </td>
                    <td>
                      {{
                        item.ult_fao !== null ? formatDate(item.ult_fao) : ''
                      }}
                      <br />
                      <div v-if="item.ult_fao != null">
                        ({{ item.qtd_faos }}
                        atendimentos)
                      </div>
                    </td>
                    <td>
                      {{
                        item.ult_fai_emulti !== null
                          ? formatDate(item.ult_fai_emulti)
                          : ''
                      }}
                      <div v-if="item.ult_fai_emulti != null">
                        ({{ item.qtd_emulti }}
                        atendimentos)
                      </div>
                    </td>
                    <td>
                      {{ item.ult_fp !== null ? formatDate(item.ult_fp) : '' }}
                      <div v-if="item.ult_fp != null">
                        ({{ item.qtd_fps }}
                        procedimentos)
                      </div>
                    </td>
                    <td>
                      {{
                        item.ult_fac !== null ? formatDate(item.ult_fac) : ''
                      }}
                      <br />
                      <div v-if="item.ult_fac != null">
                        ({{ item.qtd_facs }}
                        atendimentos)
                      </div>
                    </td>
                    <td></td>
                    <td>
                      {{
                        item.ult_fvdt !== null ? formatDate(item.ult_fvdt) : ''
                      }}
                      <br />
                      <div v-if="item.ult_fvdt != null">
                        ({{ item.qtd_fvdts }}
                        visitas)
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="
                  item.is_acompanhado == 0 &&
                  (item.qtd_atend_sem_proced == null ||
                    Number(item.qtd_atend_sem_proced) < 1)
                "
                variant="danger"
                show
                >Precisa ter pelo menos 1 atendimento individual ou 1 atividade
                coletiva de: Medicina ou Enfermagem ou Odontologia ou
                eMulti.</b-alert
              >

              <b-alert
                v-if="
                  (item.is_acompanhado == 0 || item.is_acompanhado == null) &&
                  Number(item.qtd_atend_sem_proced) < 2 &&
                  item.qtd_fps < 1
                "
                variant="danger"
                show
                >Precisa ter pelo menos 2 registros somando os atendimentos e
                procedimentos de Medicina, Enfermagem, Odontologia, eMulti ou
                Visitas domiciliares.
              </b-alert>

              <b-alert
                v-if="
                  (item.is_acompanhado == 0 || item.is_acompanhado == null) &&
                  (item.dias_fci_atualizada == null ||
                    item.dias_fci_atualizada > 730)
                "
                variant="danger"
                show
                >Precisa atualizar o cadastro individual. Lembrando de preencher
                todos os campos da ficha ao atualizar ela.</b-alert
              >

              <div class="container-table-interna">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>Atendimento</th>
                      <th>Equipe</th>
                      <th>CBO</th>
                      <th>Ficha</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item2, index2) in item.fais.fais"
                      :key="'fais-' + index2"
                    >
                      <td>
                        {{
                          item2.dt_atendimento != null
                            ? formatDate(item2.dt_atendimento)
                            : ''
                        }}
                      </td>
                      <td>{{ item2.equipe }}</td>
                      <td>{{ item2.cbo }}</td>
                      <td>{{ item2.ficha }}</td>
                    </tr>
                    <tr
                      v-for="(item3, index3) in item.fps.fps"
                      :key="'fps-' + index3"
                    >
                      <td>
                        {{
                          item3.dt_atendimento != null
                            ? formatDate(item3.dt_atendimento)
                            : ''
                        }}
                      </td>
                      <td>{{ item3.equipe }}</td>
                      <td>{{ item3.cbo }}</td>
                      <td>{{ item3.ficha }}</td>
                    </tr>
                    <tr
                      v-for="(item4, index4) in item.faos.faos"
                      :key="'faos-' + index4"
                    >
                      <td>
                        {{
                          item4.dt_atendimento != null
                            ? formatDate(item4.dt_atendimento)
                            : ''
                        }}
                      </td>
                      <td>{{ item4.equipe }}</td>
                      <td>{{ item4.cbo }}</td>
                      <td>{{ item4.ficha }}</td>
                    </tr>
                    <tr
                      v-for="(item5, index5) in item.fvdts.fvdts"
                      :key="'fvdts-' + index5"
                    >
                      <td>
                        {{
                          item5.dt_atendimento != null
                            ? formatDate(item5.dt_atendimento)
                            : ''
                        }}
                      </td>
                      <td>{{ item5.equipe }}</td>
                      <td>{{ item5.cbo }}</td>
                      <td>{{ item5.ficha }}</td>
                    </tr>
                    <tr
                      v-for="(item6, index6) in item.facs.facs"
                      :key="'facs-' + index6"
                    >
                      <td>
                        {{
                          item6.dt_atendimento != null
                            ? formatDate(item6.dt_atendimento)
                            : ''
                        }}
                      </td>
                      <td>{{ item6.equipe }}</td>
                      <td>{{ item6.cbo }}</td>
                      <td>{{ item6.ficha }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from './copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'CI',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_ficha',
          width: '200px',
        },
        {
          text: 'Acompanhamento',
          align: 'start',
          filterable: false,
          value: 'acompanhamento',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          let ultimoAcompanhamento, fais, fps, faos, fvdts, facs

          try {
            ultimoAcompanhamento = item.ultimo_acompanhamento
              ? JSON.parse(item.ultimo_acompanhamento)
              : null
          } catch (e) {
            console.error("Erro ao fazer parse de 'ultimo_acompanhamento':", e)
            ultimoAcompanhamento = null
          }

          try {
            fais = item.fais != null ? JSON.parse(item.fais) : []
          } catch (e) {
            console.error("Erro ao fazer parse de 'fais':", e)
            fais = []
          }

          try {
            fps = item.fps != null ? JSON.parse(item.fps) : []
          } catch (e) {
            console.error("Erro ao fazer parse de 'fps':", e)
            fps = []
          }

          try {
            faos = item.faos != null ? JSON.parse(item.faos) : []
          } catch (e) {
            console.error("Erro ao fazer parse de 'faos':", e)
            faos = []
          }

          try {
            fvdts = item.fvdts != null ? JSON.parse(item.fvdts) : []
          } catch (e) {
            console.error("Erro ao fazer parse de 'fvdts':", e)
            fvdts = []
          }

          try {
            facs = item.facs != null ? JSON.parse(item.facs) : []
          } catch (e) {
            console.error("Erro ao fazer parse de 'facs':", e)
            facs = []
          }

          return {
            id: index,
            ...item,
            ultimo_acompanhamento: ultimoAcompanhamento,
            fais: fais,
            fps: fps,
            faos: faos,
            fvdts: fvdts,
            facs: facs,
          }
        })
      }
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    getPagination(options) {
      this.currentPage = options.page
    },

    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}
</style>
